import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';

const DeleteB2BOrderModal = ({ open, onClose, onConfirm, orderNumber }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {getIcon('warning', { color: 'warning.main' })}
        {t('confirm_delete')}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1">
            {t('delete_b2b_order_confirmation').replace('{orderNumber}', orderNumber || t('this_order'))}
          </Typography>
          
          <Box sx={{ mt: 2, p: 2, backgroundColor: 'warning.light', borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              {t('deletion_consequences')}:
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
              <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                {t('stock_will_be_reverted')}
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                {t('credit_note_will_be_issued')}
              </Typography>
              <Typography component="li" variant="body2">
                {t('action_cannot_be_undone')}
              </Typography>
            </Box>
          </Box>
          
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteB2BOrderModal;
